import axios, { AxiosRequestConfig } from 'axios';

const getCsrfToken = (): string | null | undefined => {
    return document.querySelector('input[name="anti-csrftoken-a2z"]')?.getAttribute('value');
}

axios.interceptors.request.use((config: AxiosRequestConfig) => {
    const csrfToken = getCsrfToken();
    !!csrfToken && (config.headers['anti-csrftoken-a2z'] = csrfToken);
    return config;
});